<script lang="ts">
    //export let divider = true
    export { className as class }
    let className = ''
</script>

<!-- <div class="zflow" class:zflow-divider={!divider}> -->
<div class="zflow {className}">
    <slot />
</div>

<style>
    .zflow > :global(*:not(:last-child)) {
        border-bottom: 0px !important;
        border-bottom-left-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
    }

    .zflow > :global(*:not(:first-child)) {
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;
    }

    /* .zflow-divider > :global(*:not(:first-child)) {
        border-top: 0px !important;
    } */
</style>
